import { Instance } from 'mobx-state-tree';
import { UserInviteDtoModelBase } from './UserInviteDtoModel.base';
import { RoleNames } from './RoleNamesEnum';
import { FunctionalRole } from './TeamMemberDtoModel';

/* The TypeScript type of an instance of UserInviteDtoModel */
export interface UserInviteDtoModelType extends Instance<typeof UserInviteDtoModel.Type> {}

/* A graphql query fragment builders for UserInviteDtoModel */
export { selectFromUserInviteDto, userInviteDtoModelPrimitives, UserInviteDtoModelSelector } from './UserInviteDtoModel.base';

/**
 * UserInviteDtoModel
 */
export const UserInviteDtoModel = UserInviteDtoModelBase
  .views(self => ({
    get functionalRole(): FunctionalRole {
      return self.role?.name === RoleNames.DISPATCHER ? RoleNames.DISPATCHER : RoleNames.READ_ONLY;
    },
  }))
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
